import { styled } from "@pigment-css/react";

/**
 * Holds every toast on screen. It spans the viewport width, so it stays click-through and only the
 * capsules inside it take pointer events — otherwise an open toast swallows taps across the page.
 */
export const ToastOverlay = styled("div")(({ theme }) => ({
  position: "fixed",
  left: 0,
  right: 0,
  // Without a bottom nav the toast pins 32px from the viewport bottom instead of hovering
  // at a phantom nav height.
  bottom: `calc(var(--bottom-nav-opaque-height, ${theme.fieldSalesTwo.spacing[16]}) + ${theme.fieldSalesTwo.spacing[16]})`,
  zIndex: 1200,
  pointerEvents: "none",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[8],
}));
